import { AntragsFormular } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/AntragsFormular';
import { InfoBox } from '@/domain/navigation/benachrichtigungen/components/antragsSheet/InfoBox';
import { SchichttauschAntrag } from '@/domain/navigation/benachrichtigungen/types/SchichttauschAntrag';

export function AntragsContent({ antrag }: { antrag: SchichttauschAntrag }) {
  return (
    <div className="flex flex-col px-6">
      <InfoBox antrag={antrag} />
      <div className="flex flex-col pt-10 items-center">
        <AntragsFormular antrag={antrag} />
      </div>
    </div>
  );
}
